import { LngLat } from "react-map-gl/maplibre";

import { RanaLegend } from "@/lib/rana-legend";
import { useLizardRasterPointDataQuery } from "@/queries/query-lizard-point-data";

import { useClosestDiscreteLegendStep } from "../hooks/use-closest-discrete-legend-step";

import { PopupContent } from "./popup-content";

interface PopupRasterProps {
  descriptorId: string;
  unit: string;
  point: LngLat | null;
  layer: string;
  styleId: string;
}

export function PopupRasterInfo({ descriptorId, layer, styleId, unit, point }: PopupRasterProps) {
  const { data, isLoading, isError } = useLizardRasterPointDataQuery(descriptorId, point);
  const value = data?.results[0]?.value ?? null;
  const valueWithUnit = value !== null ? `${+value.toFixed(3)} ${unit}` : undefined;
  const { closestStep, labels } = useClosestDiscreteLegendStep({
    descriptorId,
    layer,
    styleId,
    value,
  });

  return (
    <PopupContent>
      <PopupContent.Item
        value={
          // If there is a closest legend step it means the legend is discrete
          // and we want to show the user which category the value belongs to according to the legend.
          // If there is no closest legend step it means the legend is not discrete and we can just show the value with unit.
          closestStep ? (
            <RanaLegend.LegendDiscrete legend={[closestStep]} labels={labels} />
          ) : (
            valueWithUnit
          )
        }
        {...{ isLoading, isError }}
      />
    </PopupContent>
  );
}
